import { render } from "./tree-modal.vue?vue&type=template&id=2492d3fb"
import script from "./tree-modal.vue?vue&type=script&lang=js"
export * from "./tree-modal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/simon/www/earth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__